export enum EDirection {
    from = 'from',
    to = 'to',
    OneWay = 'OneWay',
    Return = 'Return',
}
